import { render, staticRenderFns } from "./related-tags.vue?vue&type=template&id=5448c797&"
import script from "./related-tags.vue?vue&type=script&lang=ts&"
export * from "./related-tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports